import React from 'react';

export default
<g  stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
    <rect fill="currentColor" x="0" y="18" width="8" height="32"/>
    <rect fill="currentColor" x="56" y="18" width="8" height="32"/>
    <rect fill="currentColor" x="50" y="18" width="4" height="32"/>
    <rect fill="currentColor" x="10" y="18" width="4" height="32"/>
    <rect fill="currentColor" x="0" y="32" width="64" height="4"/>
</g>
